import { Route, Routes } from "react-router-dom";
import Authors from "../Pages/Authors";
import CreateArticle from "../Pages/CreateArticle";
import CreateInternalLink from "../Pages/CreateInternalLink";
import CreatePage from "../Pages/CreatePage";
import CreateAffiliateProduct from "../Pages/CreateProduct";
import Dashboard from "../Pages/Dashboard";
import EditSnippet from "../Pages/EditSnippet";
import HowTo from "../Pages/HowTo";
import MyRecentSnippets from "../Pages/MyRecentSnippets";
import AuthorSnippet from "../Pages/Snippets/AuthorSnippet";
import CategoryHeaderSnippet from "../Pages/Snippets/CategoryHeaderSnippet";
import CodeSnippet from "../Pages/Snippets/CodeSnippet";
import ContactSnippet from "../Pages/Snippets/ContactSnippet";
import EmbeddedRelatedSnippet from "../Pages/Snippets/EmbeddedRelatedSnippet";
import FaqsSnippet from "../Pages/Snippets/FaqsSnippet";
import FeaturedArticleSnippet from '../Pages/Snippets/FeaturedArticleSnippet';

import FeaturedParagraphSnippet from "../Pages/Snippets/FeaturedParagraphSnippet";
import HighLightWithLeftBorderSnippet from "../Pages/Snippets/HighLightWithLeftBorderSnippet";
import CreateImageAffiliateOfferSnippet from "../Pages/Snippets/ImageAffiliateOfferSnippet";
import ImageSnippet from "../Pages/Snippets/ImageSnippet";
import MapSnippet from "../Pages/Snippets/MapSnippet";
import RelatedCardsSnippet from "../Pages/Snippets/RelatedCardsSnippet";
import YoutubeSnippet from "../Pages/Snippets/YoutubeSnippet";
import UpdateArticle from "../Pages/UpdateArticle";

import UpdatePage from "../Pages/UpdatePage";
import UpdateProduct from "../Pages/UpdateProduct";


import CreateBrand from "../Pages/CreateBrand";
import UpdateBrand from "../Pages/UpdateBrand";

import Testing from "../Testing";
import UpdateKayakingGeo from "../Pages/UpdateKayakingGeo";

export function getRoutes() {
    return <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/create-article" element={<CreateArticle />} />

        <Route path="/create-page" element={<CreatePage />} />
        <Route path="/update-page/:domain/:url" element={<UpdatePage />} />

        <Route path="/create-brand" element={<CreateBrand />} />
        <Route path="/kayaking-geo/:id" element={<UpdateKayakingGeo />} />
        <Route path="/update-brand/:domain/:slug" element={<UpdateBrand />} />

        <Route path="/how-to" element={<HowTo />} />
        <Route path="/update-article/:id" element={<UpdateArticle />} />
        <Route path="/update-snippet/:id" element={<EditSnippet />} />
        <Route path="/update-product" element={<UpdateProduct />} />
        <Route
            path="/create-category-header-snippet"
            element={<CategoryHeaderSnippet type="create" />}
        />
        <Route
            path="/create-contact-snippet"
            element={<ContactSnippet type="create" />}
        />
        <Route
            path="/create-map-snippet"
            element={<MapSnippet type="create" />}
        />
        <Route
            path="/create-embedded-related-snippet"
            element={<EmbeddedRelatedSnippet type="create" />}
        />
        <Route
            path="/create-featured-article-snippet"
            element={<FeaturedArticleSnippet type="create" />}
        />
        <Route path="/create-code-snippet" element={<CodeSnippet type="create" />} />
        <Route
            path="/create-featured-paragraph-snippet"
            element={<FeaturedParagraphSnippet type="create" />}
        />
        <Route path="/create-image-snippet" element={<ImageSnippet type="create" />} />
        <Route
            path="/create-related-cards-snippet"
            element={<RelatedCardsSnippet type="create" />}
        />
        <Route
            path="/create-image-affiliate-offer-snippet"
            element={<CreateImageAffiliateOfferSnippet type="create" />}
        />
        <Route
            path="/create-highlight-with-left-border-snippet"
            element={<HighLightWithLeftBorderSnippet type="create" />}
        />
        <Route path="/create-product" element={<CreateAffiliateProduct />} />
        <Route path="/create-faqs-snippet" element={<FaqsSnippet type="create" />} />
        <Route path="/create-author-snippet" element={<AuthorSnippet type="create" />} />

        <Route path="/create-youtube-snippet" element={<YoutubeSnippet type="create" />} />

        <Route path="/create-internal-link" element={<CreateInternalLink />} />
        <Route path="/my-recent-snippets" element={<MyRecentSnippets />} />
        <Route path="/authors" element={<Authors />} />
        <Route path="/testing" element={<Testing />} />
    </Routes>
}